import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

/**
 * @about Converts the form fuel tank percentage (0–100) to the ratio (0–1) expected by the API.
 * A missing value stays missing so an untouched field is not saved as an explicit zero.
 */
export function toFuelTankRatio(fuelTankPercentage: number | Nullish) {
  if (isNil(fuelTankPercentage)) {
    return null;
  }

  return fuelTankPercentage / 100;
}
